import {
  SignInPageBlueprint,
  SignInPageProps,
} from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';

/**
 * `SignInPage` is an old frontend system component, so it needs the backwards
 * compatibility context to resolve legacy APIs and route refs.
 */
export const entraSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: SignInPageProps) =>
      compatWrapper(
        <SignInPage
          {...props}
          auto={process.env.NODE_ENV === 'production'}
          provider={{
            id: 'entra-auth-provider',
            title: 'Microsoft Entra',
            message: 'Sign in using Microsoft',
            apiRef: microsoftAuthApiRef,
          }}
        />,
      ),
  },
});
